import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["lightIcon", "darkIcon"]

  connect() {
    this.applyTheme()
    this.updateIcons()

    // Listen for system preference changes
    this.mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
    this.mediaQueryHandler = () => {
      if (!localStorage.theme) {
        this.applyTheme()
        this.updateIcons()
      }
    }
    this.mediaQuery.addEventListener('change', this.mediaQueryHandler)
  }

  disconnect() {
    this.mediaQuery.removeEventListener('change', this.mediaQueryHandler)
  }

  toggle() {
    const isDark = document.documentElement.classList.contains('dark')
    localStorage.theme = isDark ? 'light' : 'dark'
    this.applyTheme()
    this.updateIcons()
  }

  applyTheme() {
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
    const savedTheme = localStorage.theme

    if (savedTheme === 'dark' || (!savedTheme && prefersDark)) {
      document.documentElement.classList.add('dark')
    } else {
      document.documentElement.classList.remove('dark')
    }
  }

  updateIcons() {
    const isDark = document.documentElement.classList.contains('dark')

    if (this.hasLightIconTarget && this.hasDarkIconTarget) {
      this.lightIconTarget.classList.toggle('hidden', isDark)
      this.darkIconTarget.classList.toggle('hidden', !isDark)
    }
  }
}
